import { gql } from "@apollo/client";

export const CreateQarule = gql`
mutation CreateQarule($qarule: qaruleInput!) {
    CreateQarule(qarule: $qarule) {
        data
    }
}
`;

export const SearchQARuleEntries = gql`
  mutation SearchQarule($request: SearchQaruleRequest!) {
    SearchQarule(request: $request) {
      data
      total
    }
  }
`;

export const UpdateQaruleCollectionConfig = gql`
mutation UpdateQaruleCollectionConfig($config: JSON!, $level: Int!, $service: String!) {
  UpdateQaruleCollectionConfig(config: $config, level: $level, service: $service)
}
`;

export const UpdateQarule = gql`
mutation UpdateQarule($id: String, $qarule: qaruleInput!) {
    UpdateQarule(id: $id, qarule: $qarule) {
    id
  }
}
`;

export const SearchProviders = gql`
query SearchProviders($name: String) {
  SearchProviders(name: $name) {
    data
  }
}
`;

export const QueryQARules = gql`
  mutation QueryQarule($qaruleQuery: QaruleQuery!) {
    QueryQarule(qaruleQuery: $qaruleQuery)
  }
`;
